export function dateFormat(date = new Date(), format = 'yyyy-MM-dd HH:mm:ss') {
  try {
    date = new Date(date)
  } catch (error) {
    return ''
  }
  let yyyy = date.getFullYear()
  let MM = date.getMonth() + 1
  let dd = date.getDate()
  let HH = date.getHours()
  let mm = date.getMinutes()
  let ss = date.getSeconds()
  if (String(MM).length < 2) MM = `0${MM}`
  if (String(dd).length < 2) dd = `0${dd}`
  if (String(HH).length < 2) HH = `0${HH}`
  if (String(mm).length < 2) mm = `0${mm}`
  if (String(ss).length < 2) ss = `0${ss}`
  let result = ''

  switch (format) {
    case 'yyyy-MM-dd HH:mm:ss':
      result = `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`
      break
    case 'yyyy-MM-dd':
      result = `${yyyy}-${MM}-${dd}`
      break
    case 'HH:mm:ss':
      result = `${HH}:${mm}:${ss}`
      break
    default:
      result = `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`
      break
  }

  return result
}
